import moment from "moment";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { HyperLinkRedirectControl } from "@/Common/Components/Buttons/HyperLinkRedirectControl";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { IPatientBannerModel } from "@/Common/Models/Patient/UI/IPatientBannerModel";
import { RedirectTo } from "@/Common/Models/UI/Enums";
import { ILabModel } from "@/Labs/Models/UI/ILabModel";
import { ILabGraphsModel } from "@/Labs/Models/UI/ILabsGraphModel";
import { LabGraph } from "./LabGraph";
import { PatientBannerForLabs } from "./PatientBannerForLabs";

interface ILabGraphViewProperties {
    LabModel: ILabModel;
    GraphModel: ILabGraphsModel;
}

class LabGraphState {
    public StartDate: Date;
    public EndDate: Date;
}

class LabGraphView extends BaseReactComponent<ILabGraphViewProperties, LabGraphState> {
    constructor(props: ILabGraphViewProperties) {
        super(props);

        const initialState = new LabGraphState();
        initialState.StartDate = moment().add("years", -5).startOf("day").toDate();
        initialState.EndDate = moment().endOf("day").toDate();
        this.state = (initialState);
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        const checkedGraphsCheckboxes = this.props.GraphModel.get("ObservationTypesCheckBoxes").toArray().filter(x => x.Checked);
        const areDatesValid = moment(this.state.StartDate).isSameOrBefore(this.state.EndDate) || !this.state.StartDate || !this.state.EndDate;
        return (
            <div className="workspace">

                <div className="myle-page-header bottom-border">
                    <div className="row">
                        <div className="col-sm-12">
                            <div>
                                {this.props.LabModel.get("MylePatient") != null ? this.RenderMylePatientBanner() : this.RenderLabPatientBanner()}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="fxheight hide-overflow">
                    <div className="labs-graph-container main-content">
                        <div className="flex-container" style={{ width: "100%", justifyContent: "space-between", marginTop: "10px", marginBottom: "10px" }}>
                            <div />
                            <div style={{ marginRight: "10px" }}>
                                <strong>{cacheStore.GetString("FromDLabel")} </strong>
                                <div className="inline-block">
                                    <DateSelector
                                        date={this.state.StartDate}
                                        dateFormat="yyyy-MM-dd"
                                        disabled={false}
                                        id="labGraphStart"
                                        onChangeCallback={date => this.mutateState(s => s.StartDate = date)}
                                        valid={areDatesValid}
                                    />
                                </div>
                                <strong style={{ marginLeft: "10px" }}>{cacheStore.GetString("ToM2Label")} </strong>
                                <div className="inline-block">
                                    <DateSelector
                                        date={this.state.EndDate}
                                        dateFormat="yyyy-MM-dd"
                                        disabled={false}
                                        id="labGraphEnd"
                                        onChangeCallback={date => this.mutateState(s => s.EndDate = date)}
                                        valid={areDatesValid}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="scrollable vertical-scroll-only">
                            {checkedGraphsCheckboxes.map(
                                x => {
                                    let observationValues = this.props.GraphModel.get("Observations")[x.Id];
                                    let obx = x.Model;
                                    return (
                                        <div className="lab-component-container" key={x.Id + "_chart"}>
                                            <LabGraph
                                                StartDate={this.state.StartDate}
                                                EndDate={this.state.EndDate}
                                                MasterObservation={obx}
                                                HeaderText={obx.Text}
                                                ObservationTypeIdentifier={labsStore.GetCleanId(obx.Identifier)}
                                                Observations={observationValues}
                                            />
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    </div>
                </div>
                <div className="ws-footer table-pager-footer" />
            </div>
        );
    }

    private RenderLabPatientBanner(): JSX.Element {
        let labInfoPatient = this.props.LabModel.get("LabMessage").Model.Patient;

        return (
            <div className="row">
                <div className="col-sm-12">
                    <div><HyperLinkRedirectControl text={NameHelper.formatFullNameForHasName(labInfoPatient)} target={RedirectTo.Patient} redirectValue={null} /></div>
                    <div><span>{labInfoPatient.NAM}</span></div>
                    <div><span>{moment(labInfoPatient.DateOfBirth).format("YYYY/MM/DD")}</span></div>
                </div>
            </div>
        );
    }

    private RenderMylePatientBanner(): JSX.Element {
        const bannerModel = {
            Model: this.props.LabModel.get("MylePatient"),
            PatientDropdownVisible: false
        };
        const m: IPatientBannerModel = Immutable.fromJS(bannerModel);
        return (
            <PatientBannerForLabs
                Model={m}
                shouldLoadLastUpcomingAppointment
            />
        );
    }
}

export { ILabGraphViewProperties, LabGraphState, LabGraphView };
